import { Injectable, inject } from '@angular/core';
import { jkLib } from './jkCommon';
import { idNameItem, IOpenaiCompletionOption, IOpenaiImageOption, jkRestReturn, IOpenaiImageEditOption, IOpenaiImageVariationOption, IOpenaiTranscriptionOption, IOpenaiTranslationOption } from './jkInterface';
import { HttpClient } from '@angular/common/http';
import { ApiPort } from './apiPort';

export const openaiSizeList: idNameItem[] = [{ id: '256x256', name: '256x256' }, { id: '512x512', name: '512x512' }, { id: '1024x1024', name: '1024x1024' }];
export const openaiResponseFormatList: idNameItem[] = [{ id: 'url', name: '網址' }, { id: 'b64_json', name: 'b64_json' }];
export const developerList: idNameItem[] = [{ id: 'monica', name: 'monica' }, { id: 'openai', name: 'openai' }];

@Injectable({
  providedIn: 'root'
})
export class JkopenaiService {
  private http = inject(HttpClient);

  developerList = developerList;
  developer = 'monica';
  apiPort: ApiPort = new ApiPort();
  host: string = '';
  uid: string = '';
  token: string;
  //opt: IOpenaiCompletionOption;
  //ai: openaiCompletionOption;
  //question: string;
  answer: string = '';
  responseFormatList = [
    { id: 'json', name: 'json' },
    { id: 'text', name: 'text' },
  ]; //json, text, srt, verbose_json, or vtt.
  languageList = [
    { id: 'zh-TW', name: '中文(繁體)' },
    { id: 'zh-CN', name: '中文(簡體)' },
    // { id: 'en', name: '英文' },
    { id: 'ko', name: '韓文' },
    { id: 'ja', name: '日文' },
    { id: 'vi', name: '越南文' },
    { id: 'th', name: '泰文' },
    { id: 'fr', name: '法語' },
    { id: 'de', name: '德語' },
    { id: 'it', name: '義大利語' },
  ]; //json, text, srt, verbose_json, or vtt.
  modelList: idNameItem[] = [];
  constructor() {
    this.token = '';
  }
  init(host: string,newPort:number, uid: string):string {

    this.host = this.apiPort.init(host,newPort,1000);
    this.uid = uid;
    //let ret : jkRestReturn = await jkLib.doFetch(this.host, '/ai/chatgpt_token', '', this.token, 'get',this.opt);
    //this.token=ret.data;
    //jkLib.cloneObject(opt,this.opt);
    return this.getListModels();
  }
  async sendCompletion(opt: IOpenaiCompletionOption): Promise<string> {
    const mUrl = '/ai/completions';//'/ai/chatgpt';
    let urlParam = 'uid=' + this.uid + '&developerName='+this.developer;
    opt.user = this.uid;
    //let opt = this.opt;
    //alert('before fetch:'+JSON.stringify(opt));

    const data = await jkLib.doFetch(this.host, mUrl, urlParam, this.token, 'post', opt);
    if (data) {
      //this.question = data.question;
      this.answer = data.data;
    };

    return this.answer;
  }
  async createImage(opt: IOpenaiImageOption, ret: jkRestReturn): Promise<boolean> {
    let result = false;
    const mUrl = '/ai/openai_createImage';
    let urlParam = 'uid=' + this.uid;
    //let opt = this.opt;
    ret = await jkLib.doFetch(this.host, mUrl, urlParam, this.token, 'post', opt);
    if (ret) {
      //this.question = data.question;
      result = ret.result;
    };

    return result;
  }
  async createImageEdit(opt: IOpenaiImageEditOption, ret: jkRestReturn): Promise<boolean> {
    let result = false;
    const mUrl = '/ai/openai_createImageEdit';
    let urlParam = '';
    //let opt = this.opt;
    ret = await jkLib.doFetch(this.host, mUrl, urlParam, this.token, 'post', opt);
    if (ret) {
      //this.question = data.question;
      result = ret.result;
    };

    return result;
  }
  async createImageVariation(opt: IOpenaiImageVariationOption, ret: jkRestReturn): Promise<boolean> {
    let result = false;
    const mUrl = '/ai/openai_ImageVariation';
    let urlParam = '';
    //let opt = this.opt;
    ret = await jkLib.doFetch(this.host, mUrl, urlParam, this.token, 'post', opt);
    if (ret) {
      result = ret.result;
    };

    return result;
  }

  /**
   * 音頻轉錄為輸入語言
   * @param opt IOpenaiTranscriptionOption
   * @param ret
   */
  async createTranscription(opt: IOpenaiTranscriptionOption, ret: jkRestReturn): Promise<boolean> {
    let result = false;
    const mUrl = '/ai/openai_createTranscription';
    let urlParam = '';//'uid='+this.uid;
    //let opt = this.opt;
    ret = await jkLib.doFetch(this.host, mUrl, urlParam, this.token, 'post', opt);
    if (ret) {
      //this.question = data.question;
      result = ret.result;
    };

    return result;
  }
  async createTranslation(opt: IOpenaiTranslationOption, ret: jkRestReturn): Promise<boolean> {
    let result = false;
    const mUrl = '/ai/openai_createTranslation';
    let urlParam = ''; // 'uid='+this.uid;
    //let opt = this.opt;
    ret = await jkLib.doFetch(this.host, mUrl, urlParam, this.token, 'post', opt);
    if (ret) {
      //this.question = data.question;
      result = ret.result;
      alert(JSON.stringify(ret));
      if (!result) {
        alert('翻譯失敗:' + ret.getResultError());
      }
    } else {
      alert('ret is null');
    }

    return result;


  }
  setdefault(o: IOpenaiCompletionOption) {
    if (!o) {
      o = { n: 1, model: "", systemPrompt:"",prompt: "", temperature: 0.2 };
    }
    o.n = 1;
    o.model = ''; //this.modelList[0].id;
    o.prompt = "";
    o.temperature = 0.4; // 0.9
    o.max_tokens = 500;
    o.top_p = 1.0;
    o.frequency_penalty = 0.0;
    o.presence_penalty = 0.0;
  }
  getListModels():string {
    let model = 'gpt-4o';
    //let urlParam = 'uid='+this.uid+'&developerName=monica';
    const mUrl = this.host + '/ai/listmodels?uid=' + this.uid + '&developerName=monica';
    this.http.get(mUrl).subscribe({
      next: (ret: any) => {
        this.modelList = ret.obj;
        if(this.modelList.length>0){
          model= this.modelList[0].id;
        }
      }, error: any => {
        alert('error:' + any);
      }
    });
    //const data = await jkLib.doFetch(this.host, mUrl, urlParam, this.token, 'post',opt);
    return model;
  }
}
